// extracted by mini-css-extract-plugin
export default {"sidebar-filter":"MobileAndTabletSidebar_sidebar-filter__1GkY9","active":"MobileAndTabletSidebar_active__sWrEv"};